import ClusteringLocationOn from "../common/ClusteringLocationOn";
import {useContext, useEffect} from "react";
import ClusterContext from "./ClusterContext";
import {Marker} from "react-map-gl";
import {parseAndValidateLngLat} from "../../utils/geo";

//Handles displaying the primary markerGroup, using passed in events
const PrimaryMarkerGroup = ({
  isMultiDestination,
  destinationEvents,
  singleNonMDDestinationEvent,
  setActiveDestinationEventSelectedOnMap,
  clusteringEnabled,
}) => {
  const {registerMarkers, unRegisterMarkers} = useContext(ClusterContext);

  useEffect(() => {
    if (isMultiDestination && clusteringEnabled) {
      var filteredMarkers = destinationEvents
        .filter(
          (destinationEvent) =>
            !destinationEvent.hideLocationMarker && destinationEvent.eventId !== undefined
        )
        .map((destinationEvent) => {
          const {lat, lng, valid} = parseAndValidateLngLat(
            destinationEvent.location.longitude,
            destinationEvent.location.latitude
          );
          if (!valid) return null;
          return (
            <Marker
              key={destinationEvent.eventId}
              latitude={lat}
              longitude={lng}
              offsetLeft={-20}
              offsetTop={-40}
            >
              <ClusteringLocationOn
                destinationEvent={destinationEvent}
                onClick={() => setActiveDestinationEventSelectedOnMap(destinationEvent)}
              />
            </Marker>
          );
        });
      registerMarkers(filteredMarkers.filter(Boolean));
      return () => {
        //Unregister the markers on unmount
        unRegisterMarkers(filteredMarkers);
      };
    }
  }, [
    registerMarkers,
    unRegisterMarkers,
    destinationEvents,
    isMultiDestination,
    clusteringEnabled,
    setActiveDestinationEventSelectedOnMap,
  ]);

  return (
    <>
      {singleNonMDDestinationEvent && singleNonMDDestinationEvent.eventId !== undefined && !isMultiDestination && (() => {
        const {lat, lng, valid} = parseAndValidateLngLat(
          singleNonMDDestinationEvent.location.longitude,
          singleNonMDDestinationEvent.location.latitude
        );
        if (!valid) return null;
        return (
          <Marker
            latitude={lat}
            longitude={lng}
            offsetLeft={-20}
            offsetTop={-40}
            clusterMe={false}
          >
            <ClusteringLocationOn
              destinationEvent={singleNonMDDestinationEvent}
              onClick={() => setActiveDestinationEventSelectedOnMap(singleNonMDDestinationEvent)}
            ></ClusteringLocationOn>
          </Marker>
        );
      })()}
      {isMultiDestination &&
        !clusteringEnabled &&
        destinationEvents
          .filter(
            (destinationEvent) =>
              !destinationEvent.hideLocationMarker && destinationEvent.eventId !== undefined
          )
          .map((destinationEvent, index) => {
            const {lat, lng, valid} = parseAndValidateLngLat(
              destinationEvent.location.longitude,
              destinationEvent.location.latitude
            );
            if (!valid) return null;
            return (
              <Marker
                key={index}
                latitude={lat}
                longitude={lng}
                offsetLeft={-20}
                offsetTop={-40}
              >
                <ClusteringLocationOn
                  destinationEvent={destinationEvent}
                  onClick={() => setActiveDestinationEventSelectedOnMap(destinationEvent)}
                />
              </Marker>
            );
          })}
    </>
  );
};

export default PrimaryMarkerGroup;
